export default ({ request }) => ({
  ecomAmzSkuSpecListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzSkuSpecEditImageApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/spec/editImage',
      method: 'POST',
      data,
    })
  },
})
